// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__OurtW","col":"Table_col__1lkqW","fulfillmentStatus":"Table_fulfillmentStatus__2FxUg","emailCol":"Table_emailCol__1ErEr"};